import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

export default function ProtectedRoute({
  children,
  requireOperator = false,
  requireSiteAdmin = false,
  requireAdminConsole = false,
  requireReviewAccess = false,
  requireReportsAccess = false,
}) {
  const {
    user,
    loading,
    isOperator,
    isAdmin,
    canAccessAdminConsole,
    canReviewArticles,
    canManageFarmerReports,
    canManageOperatorPosts,
  } = useAuth();

  if (loading) {
    return <p>認証状態を確認中...</p>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (requireOperator && !isOperator) {
    return <Navigate to="/me" replace />;
  }

  if (requireAdminConsole && !canAccessAdminConsole) {
    return <Navigate to="/me" replace />;
  }

  if (requireReviewAccess && !canReviewArticles) {
    return <Navigate to="/me" replace />;
  }

  if (requireReportsAccess && !(canManageOperatorPosts || canManageFarmerReports)) {
    return <Navigate to="/me" replace />;
  }

  if (requireSiteAdmin && !isAdmin) {
    return <Navigate to="/me" replace />;
  }

  return children;
}
